import { Link, useNavigate } from 'react-router-dom';
import HelpBrowseView from '../components/help/HelpBrowseView';
import '../components/help/Help.css';

/**
 * Standalone help-index page at /help.
 *
 * Wraps the shared HelpBrowseView with page-level chrome — a top "Back"
 * link that returns the user to wherever they were before opening help.
 * We use ``navigate(-1)`` so the browser back-stack picks the right
 * destination automatically; if history is empty (deep-link entry),
 * fall back to /cases.
 */
export default function Help() {
  const navigate = useNavigate();

  const backToCaller = () => {
    // Heuristic: if there's SPA history, step back. Otherwise land at
    // the cases dashboard (the typical "home").
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/cases');
    }
  };

  // Render article titles as react-router Links so middle-click and
  // open-in-new-tab work like a normal link.
  const ArticleLink = ({ slug, className, children }) => (
    <Link to={`/help/${slug}`} className={className}>
      {children}
    </Link>
  );

  return (
    <div className="help-page">
      <button className="help-back-to-caller" onClick={backToCaller}>
        ← Back
      </button>
      <h1>Help</h1>
      <p className="help-page-subtitle">
        Guides for getting documents in, asking Arc, and managing your account.
      </p>
      <HelpBrowseView ArticleLink={ArticleLink} />
    </div>
  );
}
